export default {
  entityName: "State",
  apiEndpoint: "/master/states",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "State Name", sortable: true },
    { key: "code", label: "State Code", sortable: true, class: () => "font-mono font-bold" },
    { key: "countryId.name", label: "Country Name", sortable: true },
  ],
  fields: [
    { name: "name", label: "State Name", type: "text", required: true, placeholder: "e.g. Maharashtra" },
    { name: "code", label: "State Code", type: "text", required: true, uppercase: true, placeholder: "e.g. MH" },
    { name: "countryId", label: "Country", type: "select", required: true, lookupEndpoint: "/master/countries", placeholder: "Select Country" },
    
    // Advanced options
    { name: "effectiveFrom", label: "Effective From", type: "date", advanced: true },
    { name: "effectiveTo", label: "Effective To", type: "date", advanced: true },
  ],
  filters: [],
  workflow: {
    type: "state_approval",
    enabled: true,
  },
};
